import { render, staticRenderFns } from "./discussionBoard.vue?vue&type=template&id=60bdedfa&scoped=true&"
import script from "./discussionBoard.vue?vue&type=script&lang=js&"
export * from "./discussionBoard.vue?vue&type=script&lang=js&"
import style0 from "./discussionBoard.vue?vue&type=style&index=0&id=60bdedfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdedfa",
  null
  
)

export default component.exports